import { useEffect } from "react";
import cn from "app/util/classnames";
import IconClose from "app/icons/IconClose";

interface FullScreenPanelProps extends React.HTMLAttributes<HTMLDivElement> {
  heading?: string;
  headingClassName?: string;
  panelClassName?: string;
  childDivClassName?: string;
  hideCloseButton?: boolean;
  onClose?: () => void;
}

export default function FullScreenPanel({
  heading,
  headingClassName,
  panelClassName,
  childDivClassName,
  className,
  onClose,
  hideCloseButton,
  children,
  ...props
}: FullScreenPanelProps) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div // BACKGROUND
      className={cn(
        "flex h-full w-full grow md:items-center md:justify-center",
        "bg-green-dark",
        className,
      )}
      {...props}
    >
      <div // MAIN PANEL
        className={cn(
          "flex h-full grow flex-col lg:justify-start",
          "md:h-auto md:max-h-full md:max-w-xl",
          "lg:h-[clamp(min(calc(100vh-80px),650px),60vh,calc(100vh-80px))]",
          "bg-green-mid md:border md:border-black shadow-xl",
          "px-5 pt-1 pb-6 md:pb-4",
          panelClassName,
        )}
      >
        <div // CLOSE BUTTON DIV
          className="flex h-10 items-center justify-end px-0"
        >
          {!hideCloseButton && (
            <button
              className="flex h-10 w-10 items-center justify-end cursor-pointer"
              onClick={() => {
                onClose?.();
              }}
            >
              <IconClose />
            </button>
          )}
        </div>
        {heading && (
          <h1
            className={cn(
              "mx-auto text-2xl font-condensed uppercase",
              headingClassName,
            )}
          >
            {heading}
          </h1>
        )}
        <div className={cn("overflow-y-auto flex flex-col", childDivClassName)}>
          {children}
        </div>
      </div>
    </div>
  );
}
